import { observer } from "mobx-react-lite";
import * as React from "react";
import { getSpecTitle } from "src/business/specification";
import { ZAvailableSecSpecRow } from "src/business/specification/ZSecSpecRow";
import { columnDisplayId } from "src/business/sysData/sysColumns";
import { BlankLink } from "src/components/BlankLink";
import { MdmTable } from "src/components/MdmTable";
import { RtSelection } from "src/components/ReactiveTable/components/RtSelection";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { RtKey } from "src/components/ReactiveTable/RtTypes";
import { ToolBox2 } from "src/components/ToolBox2";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { SecSpecSelectStore } from "../SecSpecSelectStore";
import * as styles from "./shared.module.less";

type PropsSelectSpecStep = {
  store: SecSpecSelectStore;
};

export const SelectSpecStep: React.FC<PropsSelectSpecStep> = observer(
  ({ store }) => {
    const stepHeader =
      store.linkType.code === 0
        ? "Выберите вторичную спецификацию для добавления атрибутов в карточку класса"
        : "1. Выберите вторичную спецификацию для трансляции атрибутов";

    return (
      <ToolBox2
        mainTool={
          <>
            <div className={styles.stepHeader}>{stepHeader}</div>
            <RtSelection store={store.specsStore} makeOption={makeSpecOption} />
          </>
        }
      >
        <MdmTable
          store={store.specsStore}
          columns={columns}
          resizableColumns
          rowClick={{
            type: "click",
            handler: (row) => store.specsStore.setSelectedKeys([row.id]),
          }}
        />
      </ToolBox2>
    );
  },
);

const makeSpecOption = (
  key: RtKey,
  row?: ZAvailableSecSpecRow,
): { value: RtKey; label: React.ReactNode } => ({
  value: key,
  label: row ? (
    <span title={row.description ?? undefined}>{getSpecTitle(row)}</span>
  ) : (
    key
  ),
});

const columns: RtColumn<ZAvailableSecSpecRow>[] = [
  columnDisplayId,
  {
    key: "name",
    title: "Системное название",
    width: "25%",
    render: ({ id, name }) => (
      <BlankLink href={makeUrl(PageUrl.managementSecondSpecCard, { id })}>
        {name}
      </BlankLink>
    ),
  },
  {
    key: "displayName",
    title: "Название",
    width: "25%",
    render: ({ displayName }) => displayName,
  },
  {
    key: "description",
    title: "Описание",
    render: ({ description }) => description,
  },
];
